import React, { createContext } from 'react';

export const OrderSummaryContext = createContext<
  | {
      loading: boolean;
    }
  | undefined
>(undefined);

export function useOrderSummaryContext() {
  const context = React.useContext(OrderSummaryContext);

  if (context === undefined) {
    throw new Error(
      `OrderSummary compound components cannot be rendered outside the OrderSummary component`
    );
  }

  return context;
}
